import { partnerBrands } from '../../../content/partners';

export default function PartnerLogoStrip({ copy }) {
  if (partnerBrands.length === 0) return null;

  const items = Array.from(
    { length: Math.ceil(3 / partnerBrands.length) },
    () => partnerBrands,
  ).flat();

  return (
    <div className="brand-strip" role="group" aria-label={copy.label}>
      <div className="brand-strip__track">
        {[0, 1].map((copyIndex) => (
          <div
            className="brand-strip__group"
            key={copyIndex}
            data-duplicate={copyIndex === 1 ? 'true' : undefined}
            aria-hidden={copyIndex === 1 ? 'true' : undefined}
          >
            {items.map((brand, index) => (
              <span className="brand-strip__item" key={`${copyIndex}-${brand.name}-${index}`}>
                <img
                  className="brand-strip__logo brand-strip__logo--light"
                  src={brand.lightLogo}
                  alt={brand.name}
                />
                <img
                  className="brand-strip__logo brand-strip__logo--dark"
                  src={brand.darkLogo}
                  alt={brand.name}
                />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
